export const GET_MODULES = 'GET_MODULES';
export const GET_MODULES_BY_QUERY = 'GET_MODULES_BY_QUERY';
export const GET_MODULE_BY_ID = 'GET_MODULE_BY_ID';
export const ADD_MODULE = 'ADD_MODULE';
export const UPDATE_MODULE = 'UPDATE_MODULE';
export const DELETE_MODULE = 'DELETE_MODULE';
export const DELETE_MODULES_BY_RANGE = 'DELETE_MODULES_BY_RANGE';
export const SELECTED_MODULE_NULL = 'SELECTED_MODULE_NULL';

export const OPEN_MODULE_SIDEBAR = 'OPEN_MODULE_SIDEBAR';
export const DROP_DOWN_MODULES = 'DROP_DOWN_MODULES';
